exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@font-face {\n  font-family: 'NoeDisplay-Bold';\n  src: url(" + require("./NoeDisplay-Bold.eot") + "?#iefix) format('embedded-opentype'),  url(" + require("./NoeDisplay-Bold.otf") + ")  format('opentype'),\n\t     url(" + require("./NoeDisplay-Bold.woff") + ") format('woff'), url(" + require("./NoeDisplay-Bold.ttf") + ")  format('truetype'), url(" + require("./NoeDisplay-Bold.svg") + "#NoeDisplay-Bold) format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/opt/buildhome/repo/node_modules/postcss-loader?{"ident":"postcss"}!/opt/buildhome/repo/src/assets/fonts/NoeDisplay-Bold/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/fonts/NoeDisplay-Bold/styles.css
// module chunks = styles